module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_donation01-50cab2daa81eca561a6e7f82ba6004cb.jpg";